//import React, {useContext, useEffect, useState} from 'react';
import React from 'react';
import logo from "../img/dkk-logo.png";
// import logo from "../img/dansk-kennel-klub.png";
import icons from "../helpers/icons";
import {Link} from "react-router-dom";

//import {FaqContext} from "../context";
//import {useFetchFaqList} from "../components/useFetchFaqList";
//import {createApolloFetch} from "apollo-fetch";

/*
const appFetch = createApolloFetch({
    uri: 'https://dkk.staging.origin.no/api',
});
*/

export default (props) => {

    /*const {addFaqList} = useContext(FaqContext);
    const {data} = useFetchFaqList();
    addFaqList(data);
   */
    const userAuthenticated = props.userAuthenticated;
    return (
        <header className="top-bar-small" id={"tool-bar"}>
            <div className="grid-container">
                <div className="grid-x header-row">
                    <div className="cell small-24 large-16 large-offset-4">
                        <div className="tools">
                            <Link to={`/`} className="logo">
                                <img className='logo-dkk' src={logo} alt="DKK logo"/>
                                <div className="app-name">Hundedatabasen</div>
                            </Link>

                            {   !userAuthenticated &&

                                <a href={process.env.REACT_APP_BASENAME} className="log-ud">
                                    <div className="log-ud-label">LOG IND</div>
                                    <img className="icon logout" src={icons.logout} alt=""/>
                                </a>
                            }
                            {
                                userAuthenticated &&
                                <>
                                    <Link to={`/?focus=true`} className='searchButtonTop'>
                                        <img className="icon search" src={icons.search} alt=""/>
                                    </Link>
                                    <a href={process.env.REACT_APP_API_ENDPOINT + `/j_spring_cas_security_logout`} className="log-ud">
                                        <div className="log-ud-label">LOG UD</div>
                                        <img className="icon logout" src={icons.logout} alt=""/>
                                    </a>
                                </>

                            }

                        </div>
                        {props.children}
                    </div>
                </div>
            </div>
        </header>
    )
}


